import "./ComponentStyles/Footer.css";

function Footer(props) {
  return (
    <footer>
      <h4>Follow us on social media!</h4>
      <div>
        <a href="https://discord.gg/XheArAs">
          <img src={`${process.env.PUBLIC_URL}/logos/discord.png`} alt="Discord"></img>
        </a>
        <a href="https://www.youtube.com/channel/UCCnOpqYbRvSIBL7vkO_emMQ">
          <img src={`${process.env.PUBLIC_URL}/logos/youtube.png`} alt="YouTube"></img>
        </a>
        <a href="https://www.instagram.com/umbcieee/">
          <img src={`${process.env.PUBLIC_URL}/logos/instagram.png`} alt="Discord"></img>
        </a>
        <a href="https://twitter.com/umbcieee">
          <img src={`${process.env.PUBLIC_URL}/logos/twitter.png`} alt="Twitter"></img>
        </a>
      </div>
    </footer>
  );
}

export default Footer;
